import React from 'react';

import sy from '~/styles';
import {PrimaryButton} from '~/components/controls';

import InsertInvitationIcon from '~/images/md-icons/insert_invitation/materialicons/24px.svg';
import AssignmentReturnIcon from '~/images/md-icons/assignment_return/materialicons/24px.svg';
import AssignmentTurnedInIcon from '~/images/md-icons/assignment_turned_in/materialicons/24px.svg';
import PropTypes from 'prop-types';
const StageButton = ({stage, disabled, onPress}) => {
  let text;
  let icon;
  switch (stage) {
    case 'checkin':
      text = 'Afmelden';
      icon = <AssignmentTurnedInIcon fill="#FFFFFF" height={18} width={18} />;
      break;
    case 'checkout':
      text = 'Uitgeven';
      icon = <AssignmentReturnIcon fill="#FFFFFF" height={18} width={18} />;
      break;
    default:
      text = 'Reserveren';
      icon = <InsertInvitationIcon fill="#FFFFFF" height={18} width={18} />;
  }

  return (
    <PrimaryButton
      style={[sy.uppercase]}
      disabled={disabled}
      onPress={onPress}
      icon={icon}>
      <>{text}</>
    </PrimaryButton>
  );
};
StageButton.propTypes = {
  stage: PropTypes.any,
  disabled: PropTypes.any,
  onPress: PropTypes.any,
};



export default StageButton;
